export interface PosReoderTableSearchDialogResult {
  hasOrderSearched: boolean;
  orderId?: string;
}
